/**
 * Created by olga on 04.07.2025
 */

const SoonComponentView = function (component, unitView) {
    this.unitView = unitView;
    this.component = component;
    if (cleverapps.config.editorMode) {
        return;
    }

    const soonIcon = this.createSoonIcon();
    this.unitView.createAdditionalView("soonIcon", soonIcon);
};

SoonComponentView.prototype.createSoonIcon = function () {
    const styles = cleverapps.styles.SoonComponentView.icon;
    const soonIcon = new cc.Scale9Sprite(bundles.homefix.frames.task_icon_png);

    const pointer = new cc.Sprite(bundles.homefix.frames.task_icon_pointer_png);
    pointer.setAlignment(styles.pointer);
    soonIcon.addChild(pointer);

    const image = new cc.Sprite(bundles.homefix.frames.item_soon_png);
    const text = cleverapps.UI.generateOnlyText(Messages.get("Soon"), cleverapps.styles.FONTS.SOON_ICON_TEXT);

    const content = new cleverapps.Layout([image, text], {
        margin: styles.margin,
        padding: styles.padding,
        direction: cleverapps.UI.VERTICAL
    });

    soonIcon.setContentSize(content.getContentSize());
    content.setAlignment({ align: "center" }, { align: "center" });
    soonIcon.addChild(content);
    soonIcon.setAlignment({ align: "center" }, { align: "top", dy: soonIcon.height / 2 + styles.unitOffset });

    cleverapps.UI.onClick(soonIcon, this.component.unit.handleClick.bind(this.component.unit));

    return soonIcon;
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SOON_ICON_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_BROWN
    }
});

cleverapps.styles.SoonComponentView = {
    icon: {
        unitOffset: 25,
        pointer: {
            x: { align: "center" },
            y: -5
        },

        margin: 5,
        padding: {
            y: 15,
            x: 35
        }
    }

};